import { AxiosInstance } from 'axios';
import WebsiteGroupRepositoryInterface, { WebsiteGroup, WebsiteGroupItem, WebsiteGroupsResponse } from './interfaces';

export default class WebsiteGroupRepository implements WebsiteGroupRepositoryInterface {
  constructor(private readonly axios: AxiosInstance) {
  }

  public async getGroup(id: number): Promise<WebsiteGroup> {
    const resp = await this.axios.get<WebsiteGroup>(`websites/groups/${id}`);

    return resp.data;
  }

  public async getGroupByWebsite(id: number): Promise<WebsiteGroup> {
    const response = await this.axios.get(`websites/${id}/group`);

    return response.data;
  }

  public async searchGroups(
    owner: string | null | undefined,
    page?: number,
    itemsPerPage?: number,
  ): Promise<WebsiteGroupsResponse> {
    const query = new URLSearchParams();
    if (page !== undefined) {
      query.set('page', String(page));
    }

    if (owner !== undefined && owner !== null) {
      query.set('owner', String(owner));
    }

    if (!itemsPerPage) {
      itemsPerPage = 25;
    }

    query.set('itemsPerPage', String(itemsPerPage));

    const resp = await this.axios.get<WebsiteGroupsResponse>(`websites/groups?${query.toString()}`);

    return resp.data;
  }

  public async getServerGroups(server: string, user?: string): Promise<WebsiteGroupItem[]> {
    const query = new URLSearchParams();

    if (user) {
      query.set('user', user);
    }

    const response = await this.axios.get(`websites/groups/servers/${server}?${query.toString()}`);

    return response.data;
  }

  public async createGroup(id: number, mainWebsiteId: number, ownerId: number): Promise<WebsiteGroup> {
    const resp = await this.axios.post('websites/groups', {
      id,
      ownerId,
      mainWebsite: mainWebsiteId,
    });

    return resp.data;
  }

  public async deleteGroup(id: number): Promise<void> {
    await this.axios.delete(`websites/groups/${id}`);
  }

  public async terminateGroup(id: number): Promise<void> {
    await this.axios.delete(`websites/groups/${id}/termination`);
  }

  public async toggleGroup(id: number, status: string): Promise<void> {
    await this.axios.patch(`websites/groups/${id}/toggle`, {
      'status': status
    });
  }

  public async updateGroupWebsites(groupId: number, websites: number[]): Promise<void> {
    await this.axios.patch(`websites/groups/${groupId}`, {
      ids: websites,
    });
  }

  public async migrateGroup(id: number, sourceServerId: string, targetServerId: string): Promise<void> {
    await this.axios.patch(
      `websites/groups/${id}/migrate`,
      {
        originServerSource: sourceServerId,
        originServerTarget: targetServerId,
      },
    );
  }

  public async getHBOwners(): Promise<string[]> {
    const response = await this.axios.get('websites/groups/owners');

    return response.data;
  }

  public async changeGroupOwner(id: number, newOwner: string): Promise<void> {
    await this.axios.patch(`websites/groups/${id}/owner`, { newOwner });
  }

  public async changeHBId(id: number, newHBId: number): Promise<void> {
    await this.axios.patch(`websites/groups/${id}/hostbillId`, { newHBId })
  }
}
